import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Initial Assessment",
    description:
      "Conducting a comprehensive analysis of your app's current state, identifying areas for improvement, and understanding your specific requirements.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Strategic Planning",
    description:
      "Developing a tailored maintenance strategy, outlining key areas of focus, such as performance optimization, bug resolution, and feature enhancements.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Regular Monitoring",
    description:
      "Proactively monitor with real-time tools to identify issues, addressing concerns before impacting your users. ",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Scheduled Updates",
    description:
      "Planning and executing regular updates to address software vulnerabilities, enhance security, and incorporate the latest technological advancements.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Performance Optimization",
    description:
      "Thorough performance reviews, code optimization, and fine-tuning for smooth functionality across diverse devices and operating systems.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "User Feedback Integration",
    description:
      "Prioritize user feedback, incorporate valuable insights for data-driven decisions, and continuously refine the app to meet evolving expectations.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
            Our App Maintenance <span>Process</span>
             </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            Ensuring your mobile app's scalability and performance requires a meticulous approach. Our efficient process for mobile app maintenance is designed to keep your application robust and updated.
           </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
